<div class="tab-container">
    <div class="input-row">
        <div class="label">
            NYM-Kabel*
        </div>
        <div class="input-section">
            <div class="input-prefix">ca.</div>
            <input required type="number" name="nymCable" placeholder="NYM-Kabel" id="NYM-Kabel"
                   [(ngModel)]="model.installationMaterial.nymCable">
            <div class="input-unit">m</div>
        </div>
    </div>
    <div class="input-row">
        <div class="label">
            Steuerkabel*
        </div>
        <div class="input-section">
            <div class="input-prefix">ca.</div>
            <input required type="number" name="controlCable" placeholder="Steuerkabel" id="Steuerkabel"
                   [(ngModel)]="model.installationMaterial.controlCable">
            <div class="input-unit">m</div>
        </div>
    </div>
    <div class="input-row">
        <div class="label">
            Abgeschirmtes Kabel*
        </div>
        <div class="input-section">
            <div class="input-prefix">ca.</div>
            <input required type="number" name="shieldedCable" placeholder="Abgeschirmtes Kabel"
                   id="Abgeschirmtes-Kabel"
                   [(ngModel)]="model.installationMaterial.shieldedCable">
            <div class="input-unit">m</div>
        </div>
    </div>
    <div class="input-row">
        <div class="label">
            Leerrohr*
        </div>
        <div class="input-section">
            <div class="input-prefix">ca.</div>
            <input required type="number" name="emptyConduit" placeholder="Leerrohr" id="Leerrohr"
                   [(ngModel)]="model.installationMaterial.emptyConduit">
            <div class="input-unit">m</div>
        </div>
    </div>
    <div class="input-row">
        <div class="label">
            Abzweigdosen*
        </div>
        <div class="input-section">
            <div class="input-prefix">ca.</div>
            <input required type="number" name="junctionBoxes" placeholder="Abzweigdosen" id="Abzweigdosen"
                   [(ngModel)]="model.installationMaterial.junctionBoxes">
            <div class="input-unit">Stück</div>
        </div>
    </div>
    <div class="input-row">
        <div class="label">
            Temperatur-Fühler*
        </div>
        <div class="input-section">
            <div class="input-prefix"></div>
            <input required type="number" name="countTemperatureSensors" placeholder="Temperatur-Fühler"
                   id="Temperatur-Fühler"
                   [(ngModel)]="model.installationMaterial.countTemperatureSensors">
            <div class="input-unit">Stück</div>
        </div>
    </div>
    <div class="input-row">
        <div class="label">
            Stromzangen*
        </div>
        <div class="input-section">
            <div class="input-prefix"></div>
            <input required type="number" name="countElectricityClamps" placeholder="Stromzangen" id="Stromzangen"
                   [(ngModel)]="model.installationMaterial.countElectricityClamps">
            <div class="input-unit">Stück</div>
        </div>
    </div>
    <div class="input-row">
        <div class="label">
            Zähler*
        </div>
        <div class="input-section">
            <div class="input-prefix"></div>
            <input required type="number" name="countMeters" placeholder="Zähler" id="Zähler"
                   [(ngModel)]="model.installationMaterial.countMeters">
            <div class="input-unit">Stück</div>
        </div>
    </div>
    <div class="input-row">
        <div class="label">
            Module*
        </div>
        <div class="input-section">
            <div class="input-prefix"></div>
            <input required type="number" name="countModules" placeholder="Module" id="Module"
                   [(ngModel)]="model.installationMaterial.countModules">
            <div class="input-unit">Stück</div>
        </div>
    </div>
</div>
<div class="field">Pflichtfelder*</div>
<app-navigation-footer
        [isBackLinkDisabled]="false"
        [backLink]="'/gateway/general/pre-photos'"
        [isNextLinkDisabled]="!validationService.isGeneralMeasurementValid(model)"
        [nextLink]="'/gateway/general/sending'"
        [isLast]="false"
></app-navigation-footer>
